/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, Form, change, getFormValues } from 'redux-form';
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import { MenuItem } from 'material-ui/Menu';
import { CircularProgress } from 'material-ui/Progress';
import Paper from 'material-ui/Paper';
import { Link, Prompt } from 'react-router-dom';
import { FormHelperText } from 'material-ui/Form';
import Amplify from 'aws-amplify';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent } from 'material-ui/Card';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import classNames from 'classnames';
import CancelIcon from '@material-ui/icons/Cancel';
import Select from 'react-select';

import Popover from 'material-ui/Popover';
import AddIcon from 'material-ui-icons/AddCircle';
import EditIcon from 'material-ui-icons/Edit';

import Switch from 'material-ui/Switch';

import Typography from 'material-ui/Typography';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Close from 'material-ui-icons/Cancel';
import { API, graphqlOperation } from 'aws-amplify';
import { getBillingWorkflowByCustomerId, getBillingWorkflowParameters, listBillingReportTypes, getBillingRateInformation } from '../../../graphql/queries';
import ViewBillingRates from '../BillingRate/ViewBillingRates';
import renderCheckBoxGroup from '../../../helpers/RenderCheckBoxGroup';
import addEditCustomer from '../../../actions/addEditCustomer';
import addEditLocation from '../../../actions/addEditLocation';
import getCustomerGroups from '../../../actions/getCustomerGroups';
import getCustomers from '../../../actions/getCustomers';
import storeCustomerData from '../../../actions/VXC/storeCustomerData';
import storeAddressList from '../../../actions/storeAddressList';
import search from '../../../actions/search';
import RenderDialog from '../../../helpers/RenderDialog';
import { removeWhiteSpace, filterCustomersByProduct, isUserATSysAdmin } from '../../../helpers/Util';
import { ProductMap } from '../../../helpers/ProductMap';

import renderTextField from '../../../helpers/RenderTextFiledWithDiv';
import renderSelectField from '../../../helpers/RenderSelectField';
import validationHelper from '../../../helpers/ValidationHelper';
import normalizePhone from '../../../helpers/NormalizePhone';
import renderTextArea from '../../../helpers/RenderTextArea';

import RenderConfirmationTimeoutDialog from '../../../helpers/RenderConfirmationTimeoutDialog';
import renderCheckBoxItem from '../../../helpers/RenderCheckBoxItem';

import AddressForm from '../../../containers/AddressForm';
import Layout from '../../Layout';
import searchByAttribute from '../../../actions/searchByAttribute';

const styles = theme => ({
  card: {
    display: 'flex',
    boxShadow: 'none',
  },
  content: {
    flex: '1 0 auto',
  },
  contentRightCol: {
    flex: '1 0 auto',
  },
  '@media only screen and (max-width: 1000px)': {
    card: {
      display: 'block'
    }
  },
  buttonStyle: {
    marginTop: 10,
    marginBottom: 15,
    textAlign: 'center',
    width: '22%',
    marginLeft: '43%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  activityButtonStyle: {
    marginTop: 50,
    marginBottom: 20,
    textAlign: 'center',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    minWidth: 123,
    height: 36,
    color: 'white',
    textTransform: 'Capitalize'
  },
  messageStyle: {
    paddingLeft: '15px',
    paddingTop: '10px'
  },
  '@media screen and (max-width: 1130px)': {
    buttonStyle: {
      flexWrap: 'wrap',
      textAlign: 'center'
    },
  },
  '@media screen and (max-width: 600px)': {
    buttonStyle: {
      width: '30%',
      marginLeft: '33%'
    },
  },
  paperStyle: {
    width: '90%',
    height: '70%',
    display: 'inline-block',
    margin: 20,
    marginTop: '5vh'
  },
  buttonSize: {
    minWidth: 123,
    height: 36
  },
  marginStyle: {
    margin: 8
  },
  textField: {
    width: 350,
    textAlign: 'left'
  },
  textField1: {
    width: 350,
    textAlign: 'left'
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  radioGroup: {
    marginTop: '1%',
    textAlign: 'left',
    paddingLeft: '5%'
  },
  headerStyle: {
    position: 'relative',
    width: '100%',
    height: '60px',
    background: '#FFFFFF',
    boxShadow: 'none'
  },
  headerTitleStyle: {
    margin: '2%',
    fontSize: '24px',
    fontFamily: 'Roboto',
    display: 'flex',
    justifyContent: 'space-between'
  },
  addIcon: {
    position: 'absolute',
    margin: '1%'
  },
  root: {
    flexGrow: 1,
    height: 250,
  },
  input: {
    display: 'flex',
    padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
  },
  reportingLabel1: {
    color: '#ADADAD',
    textAlign: 'left',
    marginLeft: '-65%',
    fontSize: '9pt'
  },
  reportingLabel: {
    color: '#ADADAD',
    textAlign: 'left',
    marginLeft: '-70%',
    fontSize: '9pt'
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 16,
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing.unit * 2,
  },
  labelStyle : {
    color: 'rgba(0, 0, 0, 0.54)'
  },
  editGroupCB: {
    marginLeft: '0% !important',
    height: '20px',
    transform: 'scale(0.9)',
    position: 'relative',
    paddingRight: '10%'
  },
  addressDiv: {
    marginTop: '3%'
  }
});

const fieldErrorStyles = {
  display : 'flex',
  justifyContent : 'center',
  color: 'red',
  fontSize: '0.75rem'
};

const StyledPopover = withStyles({
  paper: {
    overflowX: 'visible',
    overflowY: 'visible',
  }
})(Popover);

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function ValueContainer(props) {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

function MultiValue(props) {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused,
      })}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
}

function Menu(props) {
  return (
    <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
      {props.children}
    </Paper>
  );
}

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

const validate = (values) => {
  let errors = [];
  if (sessionStorage.product !== 'VIN Cross Check') {
    errors = validationHelper.validateRequired(['customer', 'contactName', 'addressLine1', 'billingAddress', 'address', 'phoneNumber', 'emailAddress', 'autotecId', 'availableReports', 'invoiceName', 'legalName', 'displayName'], values);
  } else {
    errors = validationHelper.validateRequired(['customer', 'contactName', 'addressLine1', 'billingAddress', 'address', 'phoneNumber', 'emailAddress', 'availableReports'], values);
  }
  if (values.emailAddress && !validationHelper.validateEmail(values.emailAddress)) {
    errors.emailAddress = 'Invalid email address';
  }
  if (values.phoneNumber && !validationHelper.validatePhone(values.phoneNumber)) {
    errors.phoneNumber = 'Invalid phone number';
  }
  const lengthValidation = [
    { field: 'displayName', label: 'Display Name', value: values.displayName, min: 1, max: 50 },
    { field: 'customer', label: 'Customer', value: values.customer, min: 1, max: 50 },
    { field: 'contactName', label: 'Contact Name', value: values.contactName, min: 1, max: 50 },
    { field: 'phoneNumber', label: 'Phone Number', value: values.phoneNumber, min: 1, max: 12 },
    { field: 'emailAddress', label: 'Email Address', value: values.emailAddress, min: 1, max: 65 },
    { field: 'experianId', label: 'Primary Location Experian ID', value: values.experianId, min: 1, max: 50 },
    { field: 'address', label: 'Address', value: values.address, min: 1, max: 50 },
    { field: 'autotecPrefix', label: 'AutoTec Prefix', value: values.autotecPrefix, min: 1, max: 4 },
    { field: 'autotecId', label: 'AutoTec ID', value: values.autotecId, min: 1, max: 8 },
  ];
  validationHelper.validateLength(errors, lengthValidation);
  if (values.autotecId && !validationHelper.validateAutotecID(values.autotecId)) {
    errors.autotecId = '4 alphabetic characters + 4 numeric characters';
  }
  return errors;
};

const removeHyphens = value => value.replace(new RegExp('-', 'g'), '');

const buildReportList = (customerReports, allowedReports) => {
  const reportList = [];
  const sessionProduct = ProductMap[sessionStorage.product];

  customerReports.forEach((val) => {
    const reporttype = {
      value: val.reportTypeId,
      label: val.displayName
    };

    let allowedReportsData = [];
    if (allowedReports && !Array.isArray(allowedReports)) {
      allowedReportsData = Object.entries(allowedReports).map(e => ({ [e[0]]: e[1] }));
    } else {
      allowedReportsData = allowedReports;
    }
    if (val.methodId === '/nmvtis-report' || val.methodId === '/vehicle/history/full' ||
    val.methodId === '/vehicle/announcement') {
      if (allowedReportsData) {
        allowedReportsData.forEach((allowed) => {
          if (Object.keys(allowed)[0] === sessionProduct) {
            if (allowed[Object.keys(allowed)].includes(val.methodId)) {
              reportList.push(reporttype);
            }
          } else if (allowed.productType
                      && allowed.productType.includes(sessionProduct.toUpperCase())
                      && !reportList.includes(reporttype)) {
            reportList.push(reporttype);
          }
        });
      }
    } else {
      reportList.push(reporttype);
    }
  });

  return reportList;
};

const filterCustomerReports = (customer, reportTypes) => {
  const products = { 'VIN Cross Check': 'VXC', 'AutoCheck Insurance': 'ACI', 'AutoCheck Auctions': 'ACA' };
  const reports = [];

  customer.authorizedMethodIds.forEach((report) => {
    const filteredReports = reportTypes.filter(ft =>
      ft.productType.includes(products[sessionStorage.getItem('product')]));

    filteredReports.forEach((fr) => {
      if (fr.methodId === report) reports.push(fr);
    });
  });
  return reports;
};

class AddEditCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showVhrOwnership: false,
      showSummary: false,
      hideSummary: 'none',
      vhrOwnershipValue: 'No',
      summaryValue: 'No',
      showBillingShortcut: false,
      submissionRequired: true,
      seeBillingRates: false,
      customerReports: [],
      open: false,
      openAddress: false,
      fetching: true,
      addressList: { Address: { addressType: '*Enter an address' } },
      addressType: '',
      message: null,
      openDialog: false,
      buttonColor: '#002053',
      locationId: '',
      multi: null,
      submTypes: null,
      customers: [],
      contactName: '',
      autotecId: '',
      autotecIdNonVXC: '',
      showPrompt: <div />,
      addressSaved: false,
      postAnnouncement: false,
      autoTecIdExists: false,
      isDisplayNameExisting: false,
      fetchingLocations: false,
      customerBillingInfo: [],
      customerBillingReportInfo: [],
      customerBillingRateInfo: '',
      isFormDirty: false,
      sameAddress: false,
      sameAddressKey: '',
      isActive: null
    };
  }


  diplaySummaryCheckbox = (list) => {
    let result = false;
    list.forEach((value) => {
      if (value.label === 'All Coverage Score Report'
        || value.label === 'All Coverage Plus Score Report'
        || value.label === 'Physical Damage Score Report'
        || value.label === 'Physical Damage Plus Score Report'
      ) {
        result = true;
      }
    });
    return result;
  }

  displayOwnershipCheckbox = (list) => {
    const ownershipReports = list.filter((currentObj) => {
      if (currentObj.label) {
        // Displpay ownership checkbox when clicking the checkbox
        return currentObj.label === 'Full Vehicle History ACI'
        || currentObj.label === 'Risk Plus Score';
      }
        // Displpay ownership checkbox on page load if applicable reports
        // were previously selected
        return currentObj.displayName === 'Full Vehicle History ACI'
        || currentObj.displayName === 'Risk Plus Score';
    });

    return ownershipReports.length > 0;
  }

  async componentDidMount() {
    const { config } = this.props.data;
    await Amplify.configure({
      API: {
          graphql_endpoint: config.graphQL.graphqlEndpointBillingInfo
      }
    });
    if (this.props.match.params.id) {
      if (this.state.customers.length > 0) {
        this.props.actions.getCustomers(config, this);
        // this.shouldPromptExist();
        this.setState({ autotecId: this.state.customers.find(e => e.customerId === this.props.match.params.id).autotecId });
        this.setState({ locationId: this.state.customers.find(e => e.customerId === this.props.match.params.id).primaryLocationId });
      }
      this.props.actions.getCustomerBillingInfo(this.props.match.params.id, this.props.data.config);
      this.props.actions.getContractRates(this.props.match.params.id, this.props.data.config, this);
      this.props.actions.getPageData(this.props.match.params.id, 0, null, this.props.data.config, this);


      const custResult = await this.getCustomerBillingWorkflowId(this.props.match.params.id);
      if (custResult) {
        this.handleShowingBillingShortcut(true);
        const paramResult = await this.getBillingWorkflowParameters(custResult.billingWorkflowId);
        const billingData = await this.getBillingRateInformation(custResult.billingWorkflowId);
        const reportResults = await this.listBillingReportTypes();

        paramResult.forEach((cus) => {
          reportResults.forEach((rep) => {
            if (cus.name.includes(rep.reportTypeId)) {
              cus.reportTypeName = rep.displayName;
            }
          });
        });

        this.loadBillingInfoToState(custResult, paramResult, billingData);
      }

      if (sessionStorage.product === 'VIN Cross Check') {
        this.loadVXCCustomerData();
      }
    } else {
      this.disableFetch();
      // this.props.actions.getLocations(0, '', this.props.data.config, this);
      // if (!this.props.data.customerGroups.customerGroups) {
        //   this.props.actions.getCustomerGroups(this.props.data.config, this);
        // }
      }
    }

    disableFetch = () => {
      this.setState({ fetching: false });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data.customers !== this.props.data.customers || this.props.data.reportTypes !== prevProps.data.reportTypes) {
      this.saveNonProductReports();
      this.props.actions.getPageData(this.props.match.params.id, 0, null, this.props.data.config, this);
    }
    if (this.props.match.params.id &&
      (!this.state.fetching && !this.state.fetchingLocations) &&
      ((prevProps.formValues !== this.props.formValues) ||
      (prevState.submTypes !== this.state.submTypes) ||
      (prevState.multi !== this.state.multi))) {
        this.shouldPromptExist();
    }
  }

  async componentWillUnmount() {
    await this.props.actions.getUsers(this.props.data.config, this);
    const { config } = this.props.data;
    await Amplify.configure({
      API: {
          graphql_endpoint: config.graphQL.graphqlEndpointACIInfo
      }
    });
  }

  handleShowingBillingShortcut = (showShortcut) => {
    this.setState({ showBillingShortcut: showShortcut });
  }

  loadBillingInfoToState = (customerBillingInfo, customerBillingReportInfo, customerBillingRateInfo) => {
    this.setState({ customerBillingInfo, customerBillingReportInfo, customerBillingRateInfo });
  }

  loadVXCCustomerData = () => {
    if (localStorage.customerData && sessionStorage.product === 'VIN Cross Check') {
      const custData = JSON.parse(localStorage.customerData);
      Object.keys(custData).forEach((val) => {
        this.props.dispatch(change('AddEditCustomerForm', val, custData[val]));
      });
      if (this.state.autotecId) {
        this.props.dispatch(change('AddEditCustomerForm', 'autotecPrefix', this.state.autotecId.substring(0, 4)));
      }

      this.setState({ buttonColor: '#002053', vxcNext: true });
    }
  }

  getCustomerBillingWorkflowId = async (customerId) => {
    let custResult = [];
    try {
      custResult = await API.graphql(graphqlOperation(getBillingWorkflowByCustomerId(`customerId: "${customerId}"`)));
    } catch (error) {
        console.error(error);
    }

    return custResult.data.getBillingWorkflowByCustomerId.items[0];
  }

  getBillingWorkflowParameters = async (billingWorkflowId) => {
    let workflowResult = [];
    try {
      workflowResult = await API.graphql(graphqlOperation(getBillingWorkflowParameters(`billingWorkflowId: "${billingWorkflowId}"`)));
    } catch (error) {
        console.error(error);
    }

    if (workflowResult && workflowResult.data) {
      return workflowResult.data.getBillingWorkflowParameters;
    }
    return [];
  }

  getBillingRateInformation = async (billingWorkflowId) => {
    let result = '';
    try {
      result = await API.graphql(graphqlOperation(getBillingRateInformation(billingWorkflowId)));
    } catch (error) {
        console.error(error);
    }
    return result;
  }

  listBillingReportTypes = async () => {
    let reportResults = [];

    try {
      reportResults = await API.graphql(graphqlOperation(listBillingReportTypes()));
    } catch (error) {
        console.error(error);
    }

    if (reportResults && reportResults.data && reportResults.data.listBillingReportTypes) {
      return reportResults.data.listBillingReportTypes.billingReportTypes;
    }

    return [];
  }

  filterSelectedSubmissionTypes = () => {
    const submissionList = [];
    this.state.submTypes.map((submType) => {
      if (submType && submType.value) {
        submissionList.push(submType.value);
      }
    });

    return submissionList;
  }

  buildLocation = (event, primaryLocationId, customerId) => {
    let address;
    let addressTemplate = {};
    if (this.state.addressList['Physical Address'] && this.state.addressList['Physical Address'].addressLine1) {
      address = this.state.addressList['Physical Address'];

      addressTemplate = {
        addressLine1: removeWhiteSpace(address.addressLine1),
        city: removeWhiteSpace(address.city),
        country: removeWhiteSpace(address.country),
        county: removeWhiteSpace(address.county),
        postalCode: removeWhiteSpace(address.postalCode),
        state: removeWhiteSpace(address.state)
      };

      if (address.addressLine2) { addressTemplate.addressLine2 = removeWhiteSpace(address.addressLine2); }
    }

    const location = {
      contact: {
        contactName: removeWhiteSpace(event.contactName),
        emailAddress: removeWhiteSpace(event.emailAddress),
        phoneNumber: removeWhiteSpace(removeHyphens(event.phoneNumber))
      },
      address: addressTemplate,
      locationName: sessionStorage.product === 'VIN Cross Check' ? removeWhiteSpace(event.customer) : removeWhiteSpace(event.displayName),
      autotecId: removeWhiteSpace(event.autotecId),
      vhrOwnership: removeWhiteSpace(event.vhrOwnership)
    };

    if (primaryLocationId) {
      location.locationId = primaryLocationId;
    }

    if (customerId) {
      location.customerId = removeWhiteSpace(customerId);
    }

    return location;
  };


  buildCustomer = (event, existingCustomer) => {
    this.setState({ saving: true });
    let address;
    let addressTemplate = {};
    const authorizedMethods = [];
    const selectedMethodIds = this.state.multi ? this.state.multi.map(item => item.value) : [];
    if (sessionStorage.product !== 'VIN Cross Check') {
      if (this.state.addressList['Billing Address'] && this.state.addressList['Billing Address'].addressLine1) {
        address = this.state.addressList['Billing Address'];

        addressTemplate = {
          addressLine1: removeWhiteSpace(address.addressLine1),
          city: removeWhiteSpace(address.city),
          country: removeWhiteSpace(address.country),
          county: removeWhiteSpace(address.county),
          postalCode: removeWhiteSpace(address.postalCode),
          state: removeWhiteSpace(address.state)
        };

        if (address.addressLine2) { addressTemplate.addressLine2 = removeWhiteSpace(address.addressLine2); }
      }

      if (this.props.data.reportTypes &&
        this.props.data.reportTypes.reportTypes &&
        this.props.data.reportTypes.reportTypes.reportTypes) {
        this.props.data.reportTypes.reportTypes.reportTypes.map((e) => {
          if (this.state.multi && this.state.multi.length > 0) {
            this.state.multi.forEach((multi) => {
              if (multi.value === e.reportTypeId) {
                authorizedMethods.push(e.methodId);
              }
            });
          }
        });
      }

      const { customerReports } = this.state;

      if (customerReports) {
        customerReports.forEach((rep) => {
          this.props.data.reportTypes.reportTypes.reportTypes.forEach((reportType) => {
            if (rep === reportType.methodId && selectedMethodIds.includes(rep)) {
              reportType.productType.forEach((product) => {
                if (product.toLowerCase() !== ProductMap[sessionStorage.getItem('product')].toLowerCase()) {
                  if (!authorizedMethods.includes(rep)) {
                    authorizedMethods.push(rep);
                  }
                }
              });
            }
          });
        });
      }

      this.saveNonProductReports();
    }

    const contactTemplate = {
      contactName: event.contactName,
      emailAddress: event.emailAddress,
      phoneNumber: removeHyphens(event.phoneNumber),
    };

    // Some customers submissionType is undefined
    const submissionTypes = this.state.submTypes ?
      this.filterSelectedSubmissionTypes() : [];

    let customer;
    if (sessionStorage.product !== 'VIN Cross Check') {
      const index = authorizedMethods.indexOf('/vehicle/announcement');
      if (index !== -1) {
        authorizedMethods.splice(index, 1);
      }

      if (this.state.postAnnouncement) {
        authorizedMethods.push('/vehicle/announcement');
      }

      let vhrOwnershipValue = this.state.vhrOwnershipValue;

      if (this.state.hideOwnership !== 'inline' || !this.state.showVhrOwnership) {
        if (vhrOwnershipValue === 'Yes') vhrOwnershipValue = 'No';
      }

      customer = {
        billingAddress: addressTemplate,
        name: sessionStorage.product === 'VIN Cross Check' ? removeWhiteSpace(event.customer) : removeWhiteSpace(event.displayName),
        billingName: removeWhiteSpace(event.invoiceName),
        legalName: removeWhiteSpace(event.legalName),
        isActive: existingCustomer.isActive !== undefined ? existingCustomer.isActive : true,
        contact: contactTemplate,
        summary: existingCustomer.summary,
        availableReports: authorizedMethods,
        submissionTypes,
        vhrOwnership: vhrOwnershipValue, // this.getVhrOwnershipFromAvailableReports(event)
        autotecId: removeWhiteSpace(event.autotecId),
      };
    } else if (sessionStorage.product === 'VIN Cross Check') {
      customer = {
        name: removeWhiteSpace(event.customer),
        contact: contactTemplate,
        submissionTypes
      };

      if (this.props.match.params.id) {
        customer.customerId = this.props.match.params.id;
      }
    }

    if (event.customerGroup !== '') customer.customerGroupId = removeWhiteSpace(event.customerGroup);


    if (sessionStorage.product === 'AutoCheck Auctions') {
      customer.product = ['aca'];
    } else if (sessionStorage.product === 'AutoCheck Insurance') {
      customer.product = ['aci'];
    }

    if (existingCustomer) {
      customer.customerId = removeWhiteSpace(existingCustomer.customerId);
      customer.primaryLocationId = removeWhiteSpace(existingCustomer.primaryLocationId);
    }

    return customer;
  };

  buildAvailableReportsArray = (event) => {
    const availableReports = [];
    const { reportTypes } = this.props.data;
    Object.keys(event).forEach((key) => {
      const report = reportTypes.reportTypes.reportTypes.find(reportType => reportType.reportTypeId === key);
      if (report && report.methodId && event[key] === 'Yes') {
        availableReports.push(report.methodId);
      }
    });

    return availableReports;
  };

  handleReportAllowances = (customer) => {
    let sharedReportAllowanceData = [];
    let sharedReportAllowance = [];
    if (this.props.data.customers &&
        this.props.data.customers.data &&
        this.props.data.customers.data[0].sharedReportAllowance) {
          sharedReportAllowanceData = this.props.data.customers.data[0].sharedReportAllowance;
    }

    if (!Array.isArray(sharedReportAllowanceData)) {
      sharedReportAllowance = Object.entries(sharedReportAllowanceData).map(e => ({ [e[0]]: e[1] }));
    } else {
      sharedReportAllowance = sharedReportAllowanceData;
    }

    const reports = [];
    const tempCustomer = customer;


    if (sharedReportAllowance.length) {
      for (let i = sharedReportAllowance.length - 1; i >= 0; i--) {
        if (Object.keys(sharedReportAllowance[i]).includes(ProductMap[sessionStorage.getItem('product')])) {
          sharedReportAllowance.splice(i, 1);
        }
      }
    }

    customer.availableReports.forEach((report) => {
      if (report === '/vehicle/history/full' || report === '/nmvtis-report') {
        reports.push(report);
      }
    });

    const obj = {};
    obj[ProductMap[sessionStorage.getItem('product')]] = reports;
    sharedReportAllowance.push(obj);

    const selectedReports = [];

    if (this.props.data &&
        this.props.data.reportTypes &&
        this.props.data.reportTypes.reportTypes &&
        this.props.data.reportTypes.reportTypes &&
        this.state.multi) {
        this.props.data.reportTypes.reportTypes.reportTypes.forEach((reportType) => {
          this.state.multi.forEach((multiValue) => {
            if (multiValue.value === reportType.reportTypeId) {
              selectedReports.push(reportType.methodId);
            }
          });
        });
      }

    sharedReportAllowance.forEach((val, index) => {
      if (Object.keys(val).includes(ProductMap[sessionStorage.getItem('product')])) {
        for (let i = val[Object.keys(val)].length - 1; i >= 0; i--) {
            if (!selectedReports.includes(val[Object.keys(val)][i])) {
                val[Object.keys(val)].splice(i, 1);
            }
        }
        if (val[Object.keys(val)].length === 0) {
            delete val[Object.keys(val)];
            sharedReportAllowance.splice(index, 1);
        }
      }
    });

    tempCustomer.sharedReportAllowance = Object.assign({}, ...sharedReportAllowance);
    return tempCustomer;
  }

  handleSave = (event) => {
    const { match: { params } } = this.props;
    this.setState({ buttonColor: '#ddd', showPrompt: <div />, isFormDirty: false });
    const existingCustomer = params && params.id ?
        this.props.data.customerList.customers.customers.find(customer =>
          customer.customerId === params.id) :
        {};

      const customerData = this.state.submTypes ?
      { ...event, submissionTypes:this.filterSelectedSubmissionTypes() } :
      { ...event };

      if (event.customerGroup === '') {
        delete customerData.customerGroup;
      }
      this.props.actions.storeCustomerData(customerData);

      if (existingCustomer.isActive !== this.state.isActive) {
        existingCustomer.isActive = this.state.isActive;
      }

    existingCustomer.summary = this.state.summaryValue;

    if (sessionStorage.getItem('product') === 'VIN Cross Check' && !this.props.match.params.id) {
      this.props.history.push('/add-portfolio');
    } else if (sessionStorage.getItem('product') === 'VIN Cross Check' && this.props.match.params.id) {
      const customer = this.buildCustomer(event, existingCustomer);
      this.props.actions.saveVXCCustomer(customer, this.props.data.config, this);
    } else {
      const customer = this.buildCustomer(event, existingCustomer);
      const primaryLocation = this.buildLocation(event, customer.primaryLocationId);
      localStorage.removeItem('allRows');

      this.handleReportAllowances(customer);

      if (!this.props.match.params.id && sessionStorage.product === 'VIN Cross Check') {
        return null;
      }
        const mergedCustomer = { ...existingCustomer, ...customer };
        mergedCustomer.authorizedMethodIds = customer.availableReports;
        delete mergedCustomer.availableReports;
        this.props.actions.saveCustomer(customer, mergedCustomer, primaryLocation, this.props.data.config, this);
    }
  };

  handleClear = () => {
    this.props.history.push('/customers');
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleAgree = () => {
    this.setState({ open: false });
  };

  handleAddAddressClick = (event) => {
    this.setState({
      openAddress: true,
      anchorEl: event.currentTarget,
      addressType: event.currentTarget.id
    });
  };

  handleAutotecIdChange = (event) => {
    const autoTecIdExists = validationHelper.checkValueExist('autotecId', event.target.value, this.props.data.locationData.data);
    this.setState({
      autoTecIdExists
    });
    this.props.dispatch(change('AddEditCustomerForm', 'autotecPrefix', event.target.value.substr(0, 4)));
  };


  handleAddressClose = () => {
    this.setState({
      openAddress: false,
      anchorEl: null
    });
  };

  checkAddress = (address) => {
    if (Object.keys(address).length > 0) {
      this.setState({ addressPopulated: true });
    } else {
      this.setState({ addressPopulated: false });
    }
  }

  handleAddressSave = (addressList) => {
    this.checkAddress(addressList);
    this.props.actions.storeAddressList(addressList);
    this.setState({
      addressList,
      addressSaved: true
    });
    if (!this.props.match.params.id) {
      this.setState({ openAddress: false });
    }
  };


  handleCheckChange = (event) => {
    if (event.target.name === 'summary') {
      this.setState({ summaryValue: event.target.value });
    } else {
      this.setState({ vhrOwnershipValue: event.target.value });
    }
  }

  handleAgree = () => {
    this.props.history.push('/customers');
  }

  handleClose = () => {
    this.setState({ openDialog: false, fetching: false, saving: false });
  }

  saveAlert = () => {
    let dialog = <div />;
    if (this.state.openDialog) {
      dialog =
        (<RenderConfirmationTimeoutDialog
          open={this.state.openDialog}
          stayInAction={() => { this.handleClose(); }}
          handleIdleTimeout={() => { this.handleAgree(); }}
          timeoutInterval={this.props.data.config.ConfirmationTimeout}
          page={this.props.match.params.id ? 'Edit Customer' : 'Add Customer'}
        />);
    } else {
      dialog = (<div />);
    }
    return dialog;
  }

  changeButtonColor = () => {
    this.setState({ buttonColor: '#002053' });
  }


  handleValidationSubmissionType = (value) => {
    let submissionRequired = false;
    if (value.length) submissionRequired = true;
    this.setState({ submissionRequired });
  }

  handleChange = name => (value) => {
    if (name === 'multi') {
      if (this.displayOwnershipCheckbox(value)) {
        this.setState({ hideOwnership: 'inline' });
      } else {
        this.setState({ hideOwnership: 'none' });
      }
      this.setState({ showVhrOwnership: this.displayOwnershipCheckbox(value) });
      this.setState({ showSummary: this.diplaySummaryCheckbox(value) });
      }

    this.setState({ [name]: value });

    if (!this.props.match.params.id && name === 'submTypes') {
      const postAnnouncement = value.find(element => (element.value === 'API'));
      this.props.dispatch(change('AddEditCustomerForm', 'postAnnouncement', postAnnouncement));
      this.setState({ postAnnouncement });
    }

    this.props.dispatch(change('AddEditCustomerForm', name, value));
  };

  isEditedNameCurrentName = (editedName, customerId) => {
    const currentName = this.state.customers.find(customer => customer.customerId === customerId).name;
    return editedName === currentName;
  }

  handleDisplayNameBlur = (event) => {
    const isCurrentNameEditedName = Object.keys(this.state.customers).length > 0 ?
      this.isEditedNameCurrentName(event.target.value, this.props.match.params.id) : false;
    const isDisplayNameExisting = validationHelper.checkValueExist(
      'name',
      event.target.value,
      this.state.availableCustomersList
      )
      && !isCurrentNameEditedName;

    this.setState({
      isDisplayNameExisting
    });
  }

  initializeReportSelectBox = () => {
    const { allowedReportList } = this.props.initialValues;
    const hideOwnership = allowedReportList && this.displayOwnershipCheckbox(allowedReportList) ? 'inline' : 'none';

    this.setState({ multi: allowedReportList, hideOwnership });
  }

  populateSubmissionTypes = (subTypes) => {
    const submissionTypeList = [];

    if (subTypes) {
      subTypes.forEach((subType) => {
        const subTypeVal = subType === 'BrickFTP' ? 'SFTP' : subType;
        submissionTypeList.push({ label: subTypeVal, value: subTypeVal });
      });
    }
    this.setState({ submTypes: submissionTypeList });
  }

  wasFormChanged = () => {
    let isFormDirty = false;
    const { initialValues, formValues } = this.props;
    const { multi, submTypes } = this.state;

    if (this.props.match.params.id) {
      if (Array.isArray(multi)) {
        if (Array.isArray(initialValues.allowedReportList) &&
            initialValues.allowedReportList.length === multi.length) {
          const avialableReportsLabels = multi.map(item => item.label);
          const initialAvialableReportsLabels = initialValues.allowedReportList.map(item => item.label);
          initialAvialableReportsLabels.sort();
          avialableReportsLabels.sort();

          const searchResults = avialableReportsLabels.find((element, index) => element !== initialAvialableReportsLabels[index]);

          if (searchResults) isFormDirty = true;
        } else {
          isFormDirty = true;
        }
      }

      if (Array.isArray(submTypes)) {
        if (Array.isArray(initialValues.submTypes) &&
        initialValues.submTypes.length === submTypes.length) {
          const vinSubmissionLabels = submTypes.map(item => item.label);
          const initiaVinSubmissionLabels = initialValues.submTypes.map(item => item.label);
          initiaVinSubmissionLabels.sort();
          vinSubmissionLabels.sort();

          const searchResults = vinSubmissionLabels.find((element, index) => element !== initiaVinSubmissionLabels[index]);

          if (searchResults) isFormDirty = true;
        } else {
          isFormDirty = true;
        }
      }

      if (initialValues.contactName !== formValues.contactName) isFormDirty = true;
      else if (initialValues.displayName !== formValues.displayName) isFormDirty = true;
      else if (initialValues.customer !== formValues.customer) isFormDirty = true;
      else if (initialValues.invoiceName !== formValues.invoiceName) isFormDirty = true;
      else if (initialValues.legalName !== formValues.legalName) isFormDirty = true;
      else if (initialValues.phoneNumber !== formValues.phoneNumber) isFormDirty = true;
      else if (initialValues.emailAddress !== formValues.emailAddress) isFormDirty = true;
      else if (initialValues.autoTecPrefix !== formValues.autoTecPrefix) isFormDirty = true;
      else if (initialValues.autotecId !== formValues.autotecId) isFormDirty = true;
      else if (initialValues.emailAddress !== formValues.emailAddress) isFormDirty = true;
    }

    return isFormDirty;
  }

  shouldPromptExist = () => {
    if (this.props.match.params.id) {
      const showPrompt = (<Prompt
        when={this.wasFormChanged()}
        message="Any changes will be lost if you leave this screen. Would you like to continue?"
      />);

      this.setState({ showPrompt });
    }
  }

  togglePostAnnouncement = (postAnnouncement) => {
    this.props.dispatch(change('AddEditCustomerForm', 'postAnnouncement', postAnnouncement));
    this.setState({ postAnnouncement });
  }

  saveNonProductReports = () => {
    if (this.props.data.reportTypes &&
      this.props.data.reportTypes.reportTypes) {
    const { customers } = this.props.data;
      const { reportTypes } = this.props.data.reportTypes.reportTypes;
      const selectedReportIds = this.state.multi.map(item => item.value);
      const selectedReportMethods = reportTypes.filter(item => selectedReportIds.includes(item.reportTypeId)).map(item => item.methodId);
      let tempArr = [];

      if (customers) {
        tempArr.push(...customers.data[0].authorizedMethodIds);
        // Properly format the authorized method ids before transmitting them to the customers api
        for (let i = tempArr.length - 1; i > 0; i--) {
          if (tempArr[i].includes('_aci') || tempArr[i].includes('_aca') || tempArr[i].includes('_vxc')) {
            tempArr.splice(i, 1);
          }
        }

        if (reportTypes) {
          for (let i = reportTypes.length - 1; i >= 0; i--) {
            if (reportTypes[i].productType.includes(ProductMap[sessionStorage.getItem('product')].toUpperCase())) {
              if (tempArr.indexOf(reportTypes[i].methodId) !== -1 &&
                (reportTypes[i].methodId !== '/vehicle/history/full' &&
                reportTypes[i].methodId !== '/nmvtis-report')) {
                tempArr.splice(tempArr.indexOf(reportTypes[i].methodId), 1);
              }
            }
          }
        }

        // Sync the temporary authorized method ids with what's selected to prevent unintended report authorizations.
        tempArr = tempArr.filter(item => selectedReportMethods.includes(item) || (item === '/vehicle/announcement' && this.state.postAnnouncement));
        this.setState({ customerReports: tempArr });
      }
    }
  }

  handleAddressCheckChange = (event, key, address) => {
    let addressToSave;
    const { addressList } = this.state;
    if (event.target.checked) {
      addressToSave = { ...address, ...{ addressType : key } };
    } else {
      addressToSave = { addressType: `*Enter ${key}` };
    }
    addressList[key] = addressToSave;
    this.handleAddressSave(addressList);
    this.setState({
      sameAddress: event.target.checked,
      sameAddressKey: key
    });
  }

  handleActivityChange = (active) => {
    const deactivate = Boolean(active);
    const msg = deactivate ? 'You are about to deactivate this customer. This will also disable their associated locations and users if needed. Please type "confirm" to proceed.' : null;
    const prompt = window.prompt(msg || 'You are attempting to activate this customer. Please type "confirm" to proceed.');
    if (prompt && prompt.toLowerCase() === 'confirm') {
    this.setState({ isActive: !active });
    return active = !active;
    }
  }

  renderActivityButton = () => {
    const { classes } = this.props;
    const { isActive } = this.state;
    const locationId = localStorage.getItem('locationId');
    const locationList = JSON.parse(localStorage.getItem('person')).locations;
    const currentRole = locationList.filter(loc => loc.locationId === locationId)[0].role.name;
    let active;
    let activityButton;
    if (this.props.match.params.id && this.props.data.customers.data && currentRole !== 'user') {
      active = isActive === null ? this.props.data.customers.data[0].isActive : isActive;
      activityButton = (<div style={{ justifyContent: 'center', display: 'flex' }}>
                          <Button
                            variant="raised"
                            className={classes.activityButtonStyle}
                            style={active ? { background: 'green' } : { background: 'red' }}
                            onClick={() => { active = this.handleActivityChange(active); }}
                          >
                              { active ? 'Active' : 'Inactive' }
                          </Button>
                        </div>);
    }
    return activityButton;
  }

  render() {
    const dialog = this.saveAlert();

    const { classes, handleSubmit } = this.props;
    const { customerGroups, reportTypes } = this.props.data;
    const addressFieldList = [];
    const optionsList = [{ id: 1, label: 'Yes' }, { id: 2, label: 'No' }];

    if (!this.props.match.params.id) {
      this.props.dispatch(change('AddEditCustomerForm', 'vhrOwnership', 'No'));
    }

    const selectStyles = {
      input: base => ({
        ...base,
      }),
    };

    let address = {};
    Object.keys(this.state.addressList).forEach((key) => {
      address = this.state.addressList[key];
      const nextKey = key === 'Physical Address' ? 'Billing Address' : 'Physical Address';
      const nextAddress = this.state.addressList[nextKey];
      addressFieldList.push(<div className={classes.addressDiv} key={address.addressType}>
        {
          ((address.country === undefined && key !== 'Address') || this.state.sameAddressKey === key) &&
          <Field
            name="AddressField"
            component={renderCheckBoxItem}
            checked={this.state.sameAddress}
            option={{ id: 'AddressField', label: `${key} Same as ${nextKey}` }}
            className={classes.editGroupCB}
            label={`${key} Same as ${nextKey}`}
            handleCheckChange={e => this.handleAddressCheckChange(e, key, nextAddress)}
          />
        }
        <Field
          disabled
          name={address.addressType}
          id={address.addressType}
          component={renderTextArea}
          label={address.addressType}
          className={classes.textField1}
          divClassName={classes.marginStyle}
          rows="1"
          rowsMax="1"
        />
        {
          address.country !== undefined ?
            <EditIcon
              className={classes.addIcon}
              name={address.addressType}
              id={address.addressType}
              onClick={this.handleAddAddressClick}
            /> :
            <AddIcon
              className={classes.addIcon}
              name={address.addressType}
              id={address.addressType}
              onClick={e => this.handleAddAddressClick(e)}
            />
        }
                            </div>);
    });

    let customerGroupItems = <MenuItem key="" value="" />;
    if (customerGroups.customerGroups) {
      customerGroups.customerGroups.customerGroups.sort((a, b) => {
        if (a.customerGroupName.toLowerCase() > b.customerGroupName.toLowerCase()) {
          return 1;
        }
        if (a.customerGroupName.toLowerCase() < b.customerGroupName.toLowerCase()) {
          return -1;
        }
        return 0;
      });

      const customerGroupList = customerGroups.customerGroups.customerGroups.slice(0);
      customerGroupList.unshift({ customerGroupId: '', customerGroupName: '', isActive: true });
      customerGroupItems = customerGroupList
        .filter(e => !e.hasOwnProperty('isActive') || e.isActive)
        .map(group =>
          <MenuItem key={group.customerGroupId} value={group.customerGroupId}>{group.customerGroupName}</MenuItem>);
    }

    const vinSubmissionTypes = sessionStorage.product === 'AutoCheck Insurance'
      ? [{ label: 'API', value: 'API' }, { label: 'SFTP', value: 'SFTP' }, { label: 'UI', value: 'UI' }]
      : [{ label: 'SFTP', value: 'SFTP' }, { label: 'API', value: 'API' }, { label: 'UI', value: 'UI' }];

    const aciReportingTypes = ['Full Vehicle History', 'NMVTIS', 'Risk Plus Score', 'Risk Predictor Score'];

    let reportingSuggestions = [];
    if (reportTypes.reportTypes) {
      reportingSuggestions = reportTypes.reportTypes.reportTypes
        .filter(report => report.productType.includes(ProductMap[sessionStorage.getItem('product')].toUpperCase())
          && report.displayName !== 'Branded Title'
          && report.isActive === true)
        .map(report => ({
          value: report.reportTypeId,
          label: report.displayName,
        }));
        if (sessionStorage.getItem('product') === 'AutoCheck Auctions') { reportingSuggestions = reportingSuggestions.filter(rpt => !rpt.label.includes('Internet') && !rpt.label.includes('Risk')); }

      reportingSuggestions.sort((a, b) => {
        if (a.label.toLowerCase() > b.label.toLowerCase()) {
          return 1;
        }
        if (a.label.toLowerCase() < b.label.toLowerCase()) {
          return -1;
        }
        return 0;
      });
    }

    let button = <div align="center"><CircularProgress size={75} /></div>;

    if (!this.state.fetching && !this.state.fetchingLocations) {
      let objFound = false;
      if (this.state.addressList) {
        objFound = true;
      }
      button = (<Button
                    variant="raised"
                    className={classes.buttonSize}
                    style={((this.props.valid && !this.props.submitting) && this.state.submTypes && this.state.submTypes.length && objFound && this.state.addressSaved) && !this.state.autoTecIdExists && !this.state.isDisplayNameExisting ? { background: this.state.buttonColor } : { background: '#ddd' }}
                    disabled={!(this.props.valid) || !this.state.submTypes || !this.state.submTypes.length || this.props.submitting || this.state.buttonColor === '#ddd' || !objFound || !this.state.addressSaved || this.state.autoTecIdExists || this.state.isDisplayNameExisting}
                    type="submit"
      >{(this.state.buttonColor === '#ddd') ? 'Please wait...' : (sessionStorage.getItem('product') === 'VIN Cross Check' && !this.props.match.params.id) ? 'Next' : 'Save'}
                </Button>);
    }

    let reportTypeCheckboxes = <div />;
    let summaryCheckboxes = <div />;
    if (this.state.hideOwnership === 'inline' && this.state.showVhrOwnership) {
      reportTypeCheckboxes = (
        <div style={{ display: this.state.hideOwnership }}>
          <Field
            name="vhrOwnership"
            checked={this.state.vhrOwnershipValue}
            component={renderCheckBoxGroup}
            options={optionsList}
            className={classes.radioGroup}
            label="With Ownership?"
            handleCheckChange={this.handleCheckChange}
          />
        </div>
      );
    }

    if (this.state.showSummary) {
      summaryCheckboxes = (
        <div style={{ display: this.state.showSummary }}>
          <Field
            name="summary"
            checked={this.state.summaryValue}
            component={renderCheckBoxGroup}
            options={optionsList}
            className={classes.radioGroup}
            label="With Summary?"
            handleCheckChange={this.handleCheckChange}
          />
        </div>
      );
    }

    const showCustomerInformation = () => {
      this.setState({ seeBillingRates: false });
    };

    const showBillingInformation = () => {
      this.setState({ seeBillingRates: true });
    };

    return (
      <Layout
        className="App"
        showMenu
        menuTitle=""
        toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727."
      >
        <Paper className={classes.paperStyle}>
          {dialog}
          <AppBar position="static" className={classes.headerStyle}>
            <Toolbar className={classes.headerTitleStyle}>
              <React.Fragment>
              <Typography variant="title" className="lightH2">
                {(this.props.match.params.id) ? 'Edit Customer' : 'Add Customer'}
              </Typography>
              {this.state.showPrompt}
              <IconButton title="close" component={Link} to="/customers">
                <Close color="disabled" />
              </IconButton>
              </React.Fragment>
            </Toolbar>
          </AppBar>

          <div style={this.state.showBillingShortcut ? { width: '100%', display: 'flex', justifyContent: 'space-around' } : { display: 'none' }}>
            <span
              onClick={showCustomerInformation}
              className="menu-option"
              style={!this.state.seeBillingRates ? { textDecoration: 'underline' } : { textDecoration: 'none' }}
            >
              {(this.props.match.params.id && this.state.customerBillingReportInfo.length) ? 'Customer Information' : ''}
            </span>
            <span
              onClick={showBillingInformation}
              className="menu-option"
              style={this.state.seeBillingRates ? { textDecoration: 'underline' } : { textDecoration: 'none' }}
            >
              {(this.props.match.params.id && this.state.customerBillingReportInfo.length) ? 'Billing Information' : ''}
            </span>
          </div>
          {
            this.state.fetching || this.state.fetchingLocations ?
            <div align="center"><CircularProgress size={75} /></div>
            :
            this.state.seeBillingRates ?
            <Card className={classes.card} xs={12} sm={6}>
              <CardContent className="cardWidth">
              {this.props && this.props.data && this.props.data.contractRates && this.props.data.contractRates.contractrates &&
                <ViewBillingRates
                  classes
                  availableReports={this.state.multi}
                  contactName={this.state.contactName}
                  customerBillingInfo={this.state.customerBillingInfo}
                  customerBillingReportInfo={this.state.customerBillingReportInfo}
                  customerBillingRateInfo={this.state.customerBillingRateInfo}
                  contractRates={this.props.data && this.props.data.contractRates && this.props.data.contractRates.contractrates.data.length > 0 ?
                    this.props.data.contractRates.contractrates.data.reduce((max, cur) => max = (new Date(max.startDate) > new Date(cur.startDate)) ? max : cur) :
                    {}
                  }
                />
              }
              </CardContent>
            </Card>
            :
            <Form key="AddEditCustomerForm" onSubmit={handleSubmit((event) => { this.setState({ saving: true }); this.handleSave(event); })}>
              {
                sessionStorage.product !== 'VIN Cross Check' ?
                <Card className={classes.card} xs={12} sm={6}>

                    <CardContent className={classes.content}>
                      <React.Fragment>
                        <Field
                          name="displayName"
                          component={renderTextField}
                          label="*Display Name"
                          className={classes.textField}
                          divClassName={classes.marginStyle}
                          onBlur={this.handleDisplayNameBlur}
                        />
                        {
                          this.state.isDisplayNameExisting ?
                          <FormHelperText
                            children="Name already exists"
                            style={fieldErrorStyles}
                          />
                          : ''
                        }
                      </React.Fragment>
                      <Field
                        name="customerGroup"
                        component={renderSelectField}
                        label="Customer Group"
                        className={classes.textField}
                        divClassName={classes.formControl}
                        children={customerGroupItems}
                      />
                      <Field
                        name="invoiceName"
                        component={renderTextField}
                        label="*Invoice Name"
                        className={classes.textField}
                        divClassName={classes.marginStyle}
                      />
                      <Field
                        name="legalName"
                        component={renderTextField}
                        label="*Legal Name"
                        className={classes.textField}
                        divClassName={classes.marginStyle}
                      />
                      <Field
                        name="contactName"
                        component={renderTextField}
                        label="*Contact Name"
                        className={classes.textField}
                        divClassName={classes.marginStyle}
                      />
                      {addressFieldList}
                      <div>
                        <StyledPopover
                          open={this.state.openAddress}
                          anchorEl={this.state.anchorEl}
                          onClose={this.handleAddressClose}
                          anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                          }}
                          transformOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                          }}
                          disableRestoreFocus
                        >
                          <AddressForm
                            autotecId={this.state.autotecIdNonVXC}
                            locationId={this.state.locationId}
                            customerId={this.props.match.params.id}
                            handleAddressSave={this.handleAddressSave}
                            addressType={this.state.addressType}
                            handleAddressClose={this.handleAddressClose}
                            addressList={this.state.addressList}
                          />
                        </StyledPopover>
                      </div>
                      {!this.state.fetchingLocations && this.renderActivityButton()}
                    </CardContent>
                    <CardContent className={classes.contentRightCol}>
                    <Field
                        name="phoneNumber"
                        normalize={normalizePhone}
                        component={renderTextField}
                        label="*Phone Number"
                        className={classes.textField}
                        divClassName={classes.marginStyle}
                    />
                      <Field
                        name="emailAddress"
                        component={renderTextField}
                        label="*Email Address"
                        className={classes.textField}
                        divClassName={classes.marginStyle}
                      />
                      <Field
                        name="autotecPrefix"
                        component={renderTextField}
                        label="AutoTec Prefix"
                        className={classes.textField}
                        divClassName={classes.marginStyle}
                        disabled
                      />
                      {sessionStorage.product !== 'VIN Cross Check' ?
                          <React.Fragment>
                            {this.props.match.params.id ?
                            <React.Fragment>
                              <Field
                                name="autotecId"
                                disabled
                                component={renderTextField}
                                label="*Primary Location AutoTec ID"
                                className={classes.textField}
                                divClassName={classes.marginStyle}
                                onChange={this.handleAutotecIdChange}
                              />
                              <div
                                style={(!this.state.autoTecIdExists ?
                                  { display: 'none' } :
                                  { display: 'block', color: 'red', fontSize: '0.75rem' })}
                              >
                                This value already exists
                              </div>
                            </React.Fragment> :
                            <React.Fragment>
                              <Field
                                name="autotecId"
                                component={renderTextField}
                                label="*Primary Location AutoTec ID"
                                className={classes.textField}
                                divClassName={classes.marginStyle}
                                onChange={this.handleAutotecIdChange}
                              />
                              <div
                                style={(!this.state.autoTecIdExists ?
                                  { display: 'none' } :
                                  { display: 'block', color: 'red', fontSize: '0.75rem' })}
                              >
                                This value already exists
                              </div>
                            </React.Fragment>
                          }
                          </React.Fragment>
                        : null}
                      <Field
                        name="experianId"
                        disabled
                        component={renderTextField}
                        label="Primary Location Experian ID"
                        className={classes.textField}
                        divClassName={classes.marginStyle}
                      />

                      <div style={{ width: '360px', margin: '23px auto 0 auto' }}>
                        <label className={classes.reportingLabel1}>*VIN Submission Types</label>
                        <Select
                          classes={classes}
                          className={classes.marginStyle}
                          styles={selectStyles}
                          textFieldProps={{
                            label: 'Label',
                            InputLabelProps: {
                              shrink: true,
                            },
                          }}
                          options={vinSubmissionTypes}
                          components={components}
                          value={this.state.submTypes}
                          onChange={this.handleChange('submTypes')}
                          onBlur={event => this.handleValidationSubmissionType(event.target.value)}
                          placeholder="Select VIN submission type"
                          multi
                        />
                        {!this.state.submissionRequired &&
                          (!this.state.submTypes || !this.state.submTypes.length) &&
                          <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            color: 'red',
                            fontSize: '0.75rem'
                          }}
                          >Required
                          </div>
                        }
                      </div>
                      <div style={{ width: '360px', margin: '0 auto' }}>
                        <label className={classes.reportingLabel}>Available Reports</label>
                        <Select
                          classes={classes}
                          className={classes.marginStyle}
                          styles={selectStyles}
                          textFieldProps={{
                            label: 'Label',
                            InputLabelProps: {
                              shrink: true,
                            },
                          }}
                          menuContainerStyle={{ zIndex: 999 }}
                          options={reportingSuggestions}
                          components={components}
                          value={this.state.multi}
                          onChange={this.handleChange('multi')}
                          placeholder="Select reports to run"
                          multi
                        />
                      </div>
                      {reportTypeCheckboxes}
                      {summaryCheckboxes}
                      {sessionStorage.getItem('product') === 'AutoCheck Auctions' && (
                        <div>
                          <span className={classes.labelStyle}>Post Announcement : </span>
                          <Switch
                            checked={this.state.postAnnouncement}
                            color="primary"
                            onChange={() => {
                              this.togglePostAnnouncement(!this.state.postAnnouncement);
                            }}
                          />
                        </div>
                      )}
                      <RenderDialog
                        open={this.state.open}
                        title=""
                        message="Are you sure?  This will affect the customer�s ability to use the system."
                        onClose={this.handleClose}
                        onAgree={this.handleAgree}
                        className={classes.alertClass}
                        showActions
                      />
                    </CardContent>
                </Card>
                  :
                  <Card className={classes.card} xs={12} sm={6}>
                    <CardContent className={classes.content}>
                      <Field
                        name="customer"
                        component={renderTextField}
                        label="*Customer"
                        className={classes.textField}
                        divClassName={classes.marginStyle}
                        onBlur={this.handleDisplayNameBlur}
                      />
                      {
                          this.state.isDisplayNameExisting ?
                          <FormHelperText
                            children="Name already exists"
                            style={fieldErrorStyles}
                          />
                          : ''
                        }
                      <Field
                        name="customerGroup"
                        component={renderSelectField}
                        label="Customer Group"
                        className={classes.textField}
                        divClassName={classes.formControl}
                        children={customerGroupItems}
                      />
                      <Field
                        name="contactName"
                        component={renderTextField}
                        label="*Contact Name"
                        className={classes.textField}
                        divClassName={classes.marginStyle}
                      />
                      <Field
                        name="phoneNumber"
                        normalize={normalizePhone}
                        component={renderTextField}
                        label="*Phone Number"
                        className={classes.textField}
                        divClassName={classes.marginStyle}
                      />
                    </CardContent>
                    <CardContent className={classes.content}>
                      <Field
                        name="emailAddress"
                        component={renderTextField}
                        label="*Email Address"
                        className={classes.textField}
                        divClassName={classes.marginStyle}
                      />

                      <Field
                        name="autotecPrefix"
                        component={renderTextField}
                        label="AutoTec Prefix"
                        className={classes.textField}
                        divClassName={classes.marginStyle}
                        disabled
                      />
                      {sessionStorage.product !== 'VIN Cross Check' ?
                        <Field
                          name="autotecId"
                          disabled
                          component={renderTextField}
                          label="AutoTec ID"
                          className={classes.textField}
                          divClassName={classes.marginStyle}
                          onChange={this.handleAutotecIdChange}
                        />
                        : null}
                      <div style={{ width: '360px', margin: '23px auto 0 auto' }}>
                        <label className={classes.reportingLabel1}>*VIN Submission Types</label>
                        <Select
                          classes={classes}
                          className={classes.marginStyle}
                          styles={selectStyles}
                          textFieldProps={{
                            label: 'Label',
                            InputLabelProps: {
                              shrink: true,
                            },
                          }}
                          options={vinSubmissionTypes}
                          components={components}
                          value={this.state.submTypes}
                          onChange={this.handleChange('submTypes')}
                          onBlur={event => this.handleValidationSubmissionType(event.target.value)}
                          placeholder="Select VIN submission type"
                          multi
                        />
                        {!this.state.submissionRequired &&
                          (!this.state.submTypes || !this.state.submTypes.length) &&
                          <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            color: 'red',
                            fontSize: '0.75rem'
                          }}
                          >Required
                          </div>
                        }
                      </div>
                      {addressFieldList}
                      <div>
                        <Popover
                          open={this.state.openAddress}
                          anchorEl={this.state.anchorEl}
                          onClose={this.handleAddressClose}
                          anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                          }}
                          transformOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                          }}
                          disableRestoreFocus
                        >
                          <AddressForm
                            autotecId={this.state.autotecId}
                            locationId={this.state.locationId}
                            customerId={this.props.match.params.id}
                            handleAddressSave={this.handleAddressSave}
                            addressType={this.state.addressType}
                            handleAddressClose={this.handleAddressClose}
                            addressList={this.state.addressList}
                          />
                        </Popover>
                      </div>
                      <RenderDialog
                        open={this.state.open}
                        title=""
                        message="Are you sure?  This will affect the customer�s ability to use the system."
                        onClose={this.handleClose}
                        onAgree={this.handleAgree}
                        className={classes.alertClass}
                        showActions
                      />
                    </CardContent>
                  </Card>
              }

              <div className={classes.buttonStyle}>
                {button}
                <div className={`${classes.messageStyle} mandatory-msg`}>* Required fields</div>
              </div>
            </Form>
          }
        </Paper>
      </Layout>
    );
  }
}

AddEditCustomer.propTypes = {
  classes: PropTypes.shape().isRequired,
  theme: PropTypes.object.isRequired,
};

const initialValues = (customers, reportTypes, ownProps) => {
  const customer = (customers && customers.customers) ?
    customers.customers.filter(item => item.customerId === ownProps.match.params.id)[0] :
    {};
  const { reportTypes: reportTypesData } = reportTypes.reportTypes;

  let values = {};
  if (customer && customer.name && reportTypes.reportTypes) {
    const initialAuthorizedMethods = filterCustomerReports(customer, reportTypesData);
    values = {
      customer: customer.name,
      isActive: customer.isActive,
      displayName: customer.name,
      customerGroup: customer.customerGroupId,
      contactName: customer.contact.contactName,
      invoiceName: Object.defineProperty.hasOwnProperty.call(customer, 'billingName') ? customer.billingName : customer.name,
      legalName: Object.defineProperty.hasOwnProperty.call(customer, 'legalName') ? customer.legalName : customer.name,
      phoneNumber: normalizePhone(customer.contact.phoneNumber),
      emailAddress: customer.contact.emailAddress,
      experianId: customer.experianId,
      autotecId: customer.autotecId,
      summary: customer.summary,
      // autoTecPrefix: customer.autotecId ? customer.autotecId.substr(0, 4).toUpperCase() : '',
      submTypes: customer.submissionTypes ? customer.submissionTypes.map((subType) => {
        const subTypeVal = subType === 'BrickFTP' ? 'SFTP' : subType;
        return { label: subTypeVal, value: subTypeVal };
      }) : {},
      allowedReportList: buildReportList(initialAuthorizedMethods, reportTypesData)
    };

    const reports = [];
    customer.authorizedMethodIds.forEach((methodId) => {
      const report = reportTypes.reportTypes.reportTypes.filter(reportType => reportType.methodId === methodId);
      if (report) {
        reports.push(report[0]);
      }
    });

    // defaults all reports to 'No'
    reportTypes.reportTypes.reportTypes.forEach((report) => {
      values[report.reportTypeId] = 'No';
    });

    // changes reports to Yes if customer has report
    reports.forEach((report) => {
      if (report && report.reportTypeId) {
        values[report.reportTypeId] = 'Yes';
      }
    });
  } else {
    if (reportTypes && reportTypes.reportTypes) {
      reportTypes.reportTypes.reportTypes.forEach((report) => {
        values[report.reportTypeId] = 'No';
      });
    }
    values.customerGroup = '';
  }
  return values;
};

const mapStateToProps = (state, ownProps) => ({
  formValues: getFormValues('AddEditCustomerForm')(state),
  addressList: state.addressList,
  data: {
    addEditCustomer: state.addEditCustomer,
    addEditLocation: state.addEditLocation,
    customers: state.search.customers,
    customerList: state.customers,
    customerGroups: state.customerGroups,
    reportTypes: state.reportTypes,
    locations: state.search.locations,
    locationData: state.search.locationsList,
    config: state.config.config,
    error: state.error,
    contractRates: state.search.contractRateResult,
    isActive: state.isActive
  },
  initialValues: initialValues(
    state.customers.customers,
    state.reportTypes,
    ownProps
  )
});

const mapDispatchToProps = dispatch => ({
  actions: {
    saveVXCCustomer: (customer, config, self) => {
      self.setState({ saving: true });
      const newCustomer = customer;
      self.setState({
        buttonColor: '#ddd'
      });
      dispatch(addEditCustomer(newCustomer, config)).then((p) => {
        if (p.action.type === 'ADD_EDIT_CUSTOMER_SAVE_FULFILLED') {
          const { customerId } = p.value.data;
          dispatch(getCustomerGroups(config));
          dispatch(search('person-locations', 0, null, config));
          dispatch(search('locations', 0, null, config, true));
          dispatch(getCustomers(config));
          dispatch(search('persons', 0, null, config));
          self.setState({ message: 'Record saved', openDialog: true, fetching: false, saving: false, buttonColor: '#002053' });
        }
      });
    },
    getCustomerBillingInfo: (key, config) => {
      dispatch(searchByAttribute('contract-rates', 0, 'customerId', key, config));
    },
    saveCustomer: (customer, newMergedCustomerRecord, location, config, self) => {
      self.setState({ saving: true });
      const newLocation = location;
      const newCustomer = customer;
      const { customers } = self.props.data.customerList ? self.props.data.customerList.customers : {};
      const customerIndex = customers ? customers.findIndex(cust => cust.customerId === newMergedCustomerRecord.customerId) : -1;
      const isNewCustomer = ((customer.customerId === undefined || customer.customerId === null) && !localStorage.customerData);

      if (customerIndex > 0) {
        customers[customerIndex] = newMergedCustomerRecord;
      }
      self.setState({
        buttonColor: '#ddd'
      });
      dispatch(addEditLocation(newLocation, config)).then((o) => {
          self.setState({ saving: true });
          if (o.action.type === 'ADD_EDIT_LOCATION_SAVE_FULFILLED') {
            const { locationId } = o.value.data;
            newLocation.locationId = locationId;
            newCustomer.primaryLocationId = locationId;
            dispatch(addEditCustomer(newCustomer, config)).then((p) => {
              if (p.action.type === 'ADD_EDIT_CUSTOMER_SAVE_FULFILLED') {
                dispatch(getCustomerGroups(config));
                dispatch(search('person-locations', 0, null, config));
                dispatch(search('locations', 0, null, config, true));
                dispatch(getCustomers(config));
                dispatch(search('persons', 0, null, config));
                const userData = {
                  active: p.value.data.isActive ? '1' : '3',
                  customer: p.value.data.name,
                  autotecId: location.autotecId,
                  city: location.address.city,
                  state: location.address.state,
                  sharedReportAllowance: customer.sharedReportAllowance,
                  contactName: customer.contact.contactName,
                  isActive: p.value.data.isActive ? p.value.data.isActive : true,
                  email: customer.contact.emailAddress,
                  id: p.value.data.customerId,
                  customerId: p.value.data.customerId,
                  primaryLocationId: customer.primaryLocationId
                };
                const { customerId } = p.value.data;
                newLocation.customerId = customerId;
                dispatch(addEditLocation(newLocation, config)).then((q) => {
                  if (q.action.type === 'ADD_EDIT_LOCATION_SAVE_FULFILLED') {
                    dispatch(search('locations', 0, null, config, true));
                    if (isNewCustomer) {
                      self.props.history.push(`/add-edit-billing-information/customer/${customerId}`);
                    } else {
                      self.setState({ message: 'Record saved', openDialog: true, fetching: false, saving: false, buttonColor: '#002053' });
                    }
                  }
                });
              }
            });
          }
        }).catch(() => {
          self.setState({ buttonColor: '#002053' });
        });
      self.setState({ saving: false, fetching: false });
    },
    getCustomerGroups: (config, self) => {
      self.setState({ fetching: true });
      dispatch(getCustomerGroups(config)).then((result) => {
        if (result.action.type === 'CUSTOMER_GROUPS_FETCH_FULFILLED') {
          self.setState({
            fetching: false
          });
        }
      });
    },
    getLocations: (pageSize, key, config, self) => {
      self.setState({ fetchingLocations: true });
      dispatch(search('locations', pageSize, key, config)).then((result) => {
        if (result.action.type === 'SEARCH_FETCH_FULFILLED') {
          self.setState({ fetchingLocations: false, fetching: false });
        }
      });
    },
    getContractRates: (key, config, self) => {
      dispatch(searchByAttribute('contract-rates', 0, 'customerId', key, config)).then((contractRate) => {
        console.log('The contract rate data has been pulled');
      });
    },
    getPageData: (customerId, pageSize, key, config, self) => {
      try {
        self.setState({ fetching: true });
        const { customerList, reportTypes } = self.props.data;
        const customerInfo = customerList.customers.customers.find(customer => customer.customerId === customerId);
              dispatch(searchByAttribute('portfolios', 0, 'customerId', customerId, config)).then((portfolioInfo) => {
                if (portfolioInfo.action.type === 'SEARCH_FETCH_FULFILLED') {
                  if (portfolioInfo.action.payload.data.items[0] && portfolioInfo.action.payload.data.items[0].autotecId) {
                    self.setState({ autotecId: portfolioInfo.action.payload.data.items[0].autotecId });
                  }
                }
              });

                const locations = self.props.data.locationData.data.filter(location => location.customerId === customerId);
                  if (customerId) {
                    const customer = customerInfo;
                    self.setState({ contactName: customer.contact.contactName });
                    const { billingAddress } = customer;
                    const primaryLocation = locations.find(location => location.locationId === customer.primaryLocationId);
                    if (primaryLocation) {
                      self.setState({ autotecIdNonVXC: primaryLocation.autotecId });
                      self.setState({ locationId: primaryLocation.locationId });
                      self.props.dispatch(change('AddEditCustomerForm', 'autotecPrefix', primaryLocation.autotecId ? primaryLocation.autotecId.substring(0, 4) : ''));
                      self.props.dispatch(change('AddEditCustomerForm', 'autotecId', primaryLocation.autotecId ? primaryLocation.autotecId : ''));
                      const physicalAddress = primaryLocation.address;
                      if (billingAddress && billingAddress.addressLine1 && physicalAddress && physicalAddress.addressLine1) {
                        self.setState({
                          addressPopulated: true,
                          fetching: false,
                          addressList: {
                            'Billing Address': {
                              addressType: 'Billing Address',
                              addressLine1: billingAddress.addressLine1,
                              addressLine2: billingAddress.addressLine2 ? billingAddress.addressLine2 : '',
                              country: billingAddress.country,
                              county: billingAddress.county,
                              city: billingAddress.city,
                              state: billingAddress.state,
                              postalCode: billingAddress.postalCode
                            },
                            'Physical Address': {
                              addressType: 'Physical Address',
                              addressLine1: physicalAddress.addressLine1,
                              addressLine2: physicalAddress.addressLine2,
                              country: physicalAddress.country,
                              county: physicalAddress.county,
                              city: physicalAddress.city,
                              state: physicalAddress.state,
                              postalCode: physicalAddress.postalCode
                            }
                          },
                          addressSaved: true
                        });
                      } else if ((!billingAddress || !billingAddress.addressLine1) && physicalAddress && physicalAddress.addressLine1) {
                        self.setState({
                          addressList: {
                            'Physical Address': {
                              addressType: 'Physical Address',
                              addressLine1: physicalAddress.addressLine1,
                              addressLine2: physicalAddress.addressLine2,
                              country: physicalAddress.country,
                              county: physicalAddress.county,
                              city: physicalAddress.city,
                              state: physicalAddress.state,
                              postalCode: physicalAddress.postalCode
                            },
                            'Billing Address': { addressType: '*Enter Billing Address' }
                          },
                          addressSaved: true
                        });
                      } else if (billingAddress) {
                        self.setState({
                          addressList: {
                            'Billing Address': {
                              addressType: 'Billing Address',
                              addressLine1: billingAddress.addressLine1,
                              addressLine2: billingAddress.addressLine2 ? billingAddress.addressLine2 : '',
                              country: billingAddress.country,
                              county: billingAddress.county,
                              city: billingAddress.city,
                              state: billingAddress.state,
                              postalCode: billingAddress.postalCode
                            },
                            'Physical Address': { addressType: '*Enter Physical address' }
                          },
                          addressSaved: true
                        });
                      }
                    } else if (billingAddress) {
                      self.setState({
                        addressList: {
                          'Billing Address': {
                            addressType: 'Billing Address',
                            addressLine1: billingAddress.addressLine1,
                            addressLine2: billingAddress.addressLine2 ? billingAddress.addressLine2 : '',
                            country: billingAddress.country,
                            county: billingAddress.county,
                            city: billingAddress.city,
                            state: billingAddress.state,
                            postalCode: billingAddress.postalCode
                          },
                          'Physical Address': { addressType: '*Enter Physical Address' }
                        },
                        addressSaved: true
                      });
                    } else {
                      console.error('We do not have a billing or physical address');
                    }
                  }

                  self.setState({ fetching: false, buttonColor: '#002053' });

              if (customerId) {
                const customer = customerInfo;
                const ownershipSelected = (customer && customer.vhrOwnership === 'Yes');
                self.props.dispatch(change('AddEditCustomerForm', 'vhrOwnership', ((ownershipSelected) ? 'Yes' : 'No')));
                const showOwnership = (customer && customer.authorizedMethodIds && customer.authorizedMethodIds.includes('/vehicle/history/full'));
                const showSummary = (customer && customer.authorizedMethodIds && sessionStorage.getItem('product') === 'AutoCheck Insurance' &&
                  (customer.authorizedMethodIds.includes('/vehicle/risk/physicaldamage') || customer.authorizedMethodIds.includes('/vehicle/risk/allcoverage')));
                const showVhrOwnership = (customer && sessionStorage.getItem('product') === 'AutoCheck Insurance');
                const postAnnouncement = (customer.authorizedMethodIds.includes('/vehicle/announcement'));
                self.setState({ hideOwnership: (showOwnership) ? 'inline' : 'none', showVhrOwnership, postAnnouncement });
                self.setState({ summaryValue: customer.summary ? customer.summary : 'No', hideSummary: (showSummary) ? 'inline' : 'none', showSummary });
                self.setState({ vhrOwnershipValue: customer.vhrOwnership, isActive: ('isActive' in customer) ? customer.isActive : true });
                self.populateSubmissionTypes(customer.submissionTypes);
              }
              self.setState({ hideOwnership: 'none', customers: customerList.customers.customers });
              self.initializeReportSelectBox();
      } catch (e) {
        window.history.back();
      } finally {
        self.setState({ fetching: false });
      }
    },
    getCustomers: (config, self) => {
      const { customerList } = self.props.data;
      const customersList = customerList.customers.customers;
      const product = ProductMap[sessionStorage.getItem('product')];

      // dispatch(getCustomers(config)).then((result) => {
      //     let { customers } = result.value.data;
      const isATSysAdmin = isUserATSysAdmin(localStorage.getItem('customerId'));
      const customers = filterCustomersByProduct(product, customersList.localStorage.getItem('customerId'), isATSysAdmin);
      self.setState({ availableCustomersList: customers });
      // });
    },
    getUsers: (config, self, personList) => {
      dispatch(search('persons', 0, null, config));
      self.setState({ persons: personList });
    },
    storeCustomerData: (value) => {
      dispatch(storeCustomerData(value));
    },
    storeAddressList: (value) => {
      dispatch(storeAddressList(value));
    }

  }
});

const ReduxForm = withStyles(styles, { withTheme: true })(reduxForm({
  form: 'AddEditCustomerForm',
  enableReinitialize: true,
  validate
})(AddEditCustomer));

const ConnectedAddEditCustomer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReduxForm);

export default ConnectedAddEditCustomer;


// WEBPACK FOOTER //
// ./src/components/Customer/Customer/AddEditCustomer.js